<template>
  <div>
    <img
      class="w-100"
      src="@/assets/Kopfstand.jpg"
      alt="Frau macht Kopfstand im Schnee vor Bergpanorama"
    >
    <div
      class="p-4"
    >
      <h6 v-if="!showFancyScrollbar">
        Wie gehe ich Veränderungen an?
      </h6>
      <p>
        Eine Veränderung ist immer ein Prozess.
        Als Grundlage dient eine Analyse der aktuellen Situation und Historie
        sowie der genauen Zielsetzung. Mir ist es essentiell wichtig,
        Veränderungen nachhaltig zu verankern. Dies geschieht durch die richtigen
        Fragen und Methoden, die Reflexion fördern und langfristig zum Umdenken inspirieren.
        Dabei befähige ich die Menschen, auch nach dem von mir begleiteten Prozess eigenständig
        an ihrer Entwicklung weiterarbeiten zu können. Bei jedem Schritt basiert meine
        Herangehensweise auf Wertschätzung, Struktur und Offenheit.
      </p>
      <p>
        Vor dem Start Eures indiviuduellen Veränderungsprozesses passen wir diesen
        gemeinsam optimal auf Eure Bedürfnisse an.
      </p>
      <p>
        <a
          href="#contact"
        >Kontaktiert</a> mich jetzt für ein unverbindliches Vorgespräch.
      </p>
      <!--
      Die wichtisten Bausteine meiner Arbeit sind für mich:
      <div class="p-4">
        <ul>
          <li>
            Wertschätzung
            <p>
              Damit Weiterentwicklung funktionieren kann,
              braucht es Anerkennung für das, was war,
              was ist und was sein wird. Ich lebe ein vertrauensvolles und empathisches Miteinander
              und motiviere alle Involvierten dazu, dies auch zu tun.
            </p>
          </li>
          <li>
            Struktur
            <p>
              Damit Prozesse und Veränderungen nachvollziehbar gestalten sind,
              braucht es ein hohes Maß an Struktur & Analysefähigkeit.
              Ich behalte immer den Blick aufs große Ganze und schaue aus der Meta-Ebene
              auf den gesamten Verlauf des Veränderungsprozesses. So finde ich die Ansatzpunkte,
              die Ihnen nachhaltig nützen.
            </p>
          </li>
          <li>
            Offenheit
            <p>
              Zum einen beinhaltet dieser Wert für mich, Dinge offen anzusprechen und transparent
              zu kommunizieren. Zum anderen bedeutet das für mich auch, offen gegenüber
              allem Neuen zu sein und zu bleiben und unvoreingenommen an alles heranzugehen.
            </p>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showFancyScrollbar: { type: Boolean, required: true },
  },
};
</script>
